import {Component, OnInit} from '@angular/core';


@Component({
    selector: 'master-detail-root',
    templateUrl: './master-detail-root.page.html',
    styleUrls: ['./master-detail-root.page.scss']
})
export class MasterDetailRootComponent  {
}
